import Loader from "@/components/Common/kpi/Loader";
import clsxm from "@/lib/clsxm";
import {ROUTES_WITHOUT_NAVBAR} from "@/store/constants";
import {useLocation} from "@tanstack/react-router";
import {type FC} from "react";

const FullPageLoader: FC = () => {
  const location = useLocation();

  return (
    <Loader
      styles={{
        containerClassName: clsxm(
          "w-full items-center",
          ROUTES_WITHOUT_NAVBAR.some(route => location.pathname.includes(route)) ? "h-screen" : "h-[calc(100vh-64px)]",
        ),
        loaderClassName: "size-20",
      }}
    />
  );
};

export default FullPageLoader;
